













































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import moment from "moment";
import { SupportUsers } from "@/http/api/v2/supporter/users";
import { SupportAuditDto, SupportUserDto } from "@/http/dto/supportUser";

const HotelModule = namespace("HotelModule");

@Component
export default class UserManagement extends Vue {
  @HotelModule.State("hotelObjectId") hotelObjectId!: string;

  status: "active" | "deleted" | "all" = "active";
  keyword = "";
  current = 1;
  total = 0;
  activeTotal = 0;
  deletedTotal = 0;
  recentLoginTotal = 0;
  loading = false;
  errorMessage = "";
  data: SupportUserDto[] = [];

  resetTarget: SupportUserDto | null = null;
  resetting = false;
  resetForm = { password: "", confirm: "", reason: "" };

  auditVisible = false;
  auditLoading = false;
  auditTarget: SupportUserDto | null = null;
  audits: SupportAuditDto[] = [];
  auditTotal = 0;
  auditPage = 1;

  get hotelObjectIdValue() {
    return this.hotelObjectId;
  }

  @Watch("hotelObjectIdValue")
  hotelObjectIdChanged() {
    this.current = 1;
    this.load();
  }

  get statusText() {
    return { active: "사용 중", deleted: "삭제 계정", all: "전체" }[this.status];
  }

  get pagination() {
    return {
      total: this.total,
      pageSize: 20,
      current: this.current,
      showTotal: (total: number) => `총 ${this.number(total)}명`,
      showSizeChanger: false,
    };
  }

  get columns() {
    return [
      {
        title: "사용자",
        dataIndex: "account",
        width: 190,
        fixed: "left",
        scopedSlots: { customRender: "account" },
      },
      {
        title: "소속 호텔",
        dataIndex: "hotels",
        width: 260,
        scopedSlots: { customRender: "hotels" },
      },
      {
        title: "연락처",
        dataIndex: "contact",
        width: 200,
        scopedSlots: { customRender: "contact" },
      },
      {
        title: "계정 권한",
        dataIndex: "role",
        width: 100,
        scopedSlots: { customRender: "role" },
      },
      {
        title: "마지막 접속",
        dataIndex: "lastChallengeTime",
        width: 160,
        scopedSlots: { customRender: "login" },
      },
      {
        title: "가입일",
        dataIndex: "createdTime",
        width: 110,
        customRender: (value: string) => moment(value).format("YYYY.MM.DD"),
      },
      {
        title: "초기화 기록",
        dataIndex: "resetHistory",
        width: 145,
        scopedSlots: { customRender: "resetHistory" },
      },
      {
        title: "관리",
        dataIndex: "actions",
        width: 140,
        fixed: "right",
        scopedSlots: { customRender: "actions" },
      },
    ];
  }

  get resetRules() {
    return {
      password: [
        { required: true, message: "새 임시 비밀번호를 입력해주세요." },
        {
          pattern: /^(?=.*[A-Za-z])(?=.*\d).{8,100}$/,
          message: "영문과 숫자를 포함해 8자 이상 입력해주세요.",
        },
      ],
      confirm: [{ required: true, message: "비밀번호를 한 번 더 입력해주세요." }],
      reason: [
        { required: true, message: "초기화 사유를 입력해주세요." },
        { min: 2, max: 200, message: "사유를 2자 이상 200자 이하로 입력해주세요." },
      ],
    };
  }

  mounted() {
    this.load();
  }

  number(value: number) {
    return Number(value || 0).toLocaleString("ko-KR");
  }

  dateTime(value: string) {
    return moment(value).format("YYYY.MM.DD HH:mm");
  }

  relativeTime(value: string) {
    const days = moment().diff(moment(value), "days");
    if (days < 1) return "오늘";
    if (days < 30) return `${days}일 전`;
    return `${Math.floor(days / 30)}개월 전`;
  }

  roleText(value: string) {
    const labels: { [key: string]: string } = {
      Developer: "개발자",
      Anonymous: "미소속",
      User: "사용자",
      Admin: "관리자",
      Owner: "마스터",
      Supporter: "지원 담당",
    };
    return labels[value] || value;
  }

  roleColor(value: string) {
    const colors: { [key: string]: string } = {
      Developer: "purple",
      Supporter: "cyan",
      Owner: "gold",
      Admin: "blue",
      User: "green",
      Anonymous: "default",
    };
    return colors[value] || "default";
  }

  changeStatus() {
    this.current = 1;
    this.load();
  }

  search() {
    this.current = 1;
    this.load();
  }

  async load(pagination?: any) {
    try {
      this.loading = true;
      this.errorMessage = "";
      const current = pagination && pagination.current ? pagination.current : this.current;
      const result = await SupportUsers.getUsers({
        page: current,
        take: 20,
        keyword: this.keyword || undefined,
        hotelObjectId: this.hotelObjectId || undefined,
        status: this.status,
      });
      this.current = result.page;
      this.total = result.total;
      this.activeTotal = result.activeTotal;
      this.deletedTotal = result.deletedTotal;
      this.recentLoginTotal = result.recentLoginTotal;
      this.data = result.items;
    } catch (error) {
      this.errorMessage = "사용자 정보를 불러오지 못했습니다. 잠시 후 다시 시도해주세요.";
    } finally {
      this.loading = false;
    }
  }

  openReset(user: SupportUserDto) {
    this.resetTarget = user;
    this.resetForm = { password: "", confirm: "", reason: "" };
  }

  closeReset() {
    if (this.resetting) return;
    this.resetTarget = null;
    this.resetForm = { password: "", confirm: "", reason: "" };
  }

  applyReset() {
    const form: any = this.$refs.resetForm;
    form.validate(async (valid: boolean) => {
      if (!valid || !this.resetTarget) return;
      if (this.resetForm.password !== this.resetForm.confirm) {
        this.$message.warning("비밀번호 확인 값이 일치하지 않습니다.");
        return;
      }

      try {
        this.resetting = true;
        await SupportUsers.resetPassword(this.resetTarget.objectId, {
          password: this.resetForm.password,
          reason: this.resetForm.reason.trim(),
        });
        this.$message.success("비밀번호를 초기화하고 감사기록을 저장했습니다.");
        this.resetTarget = null;
        this.resetForm = { password: "", confirm: "", reason: "" };
        await this.load();
      } catch (error) {
        const message = (error as any).response?.data?.message;
        this.$message.error(message || "비밀번호 초기화에 실패했습니다.");
      } finally {
        this.resetting = false;
      }
    });
  }

  openAudits(user?: SupportUserDto) {
    this.auditTarget = user || null;
    this.auditPage = 1;
    this.auditVisible = true;
    this.loadAudits(1);
  }

  closeAudits() {
    this.auditVisible = false;
    this.auditTarget = null;
    this.audits = [];
    this.auditTotal = 0;
  }

  async loadAudits(page: number) {
    try {
      this.auditLoading = true;
      const result = await SupportUsers.getPasswordResets({
        page,
        take: 20,
        targetUserObjectId: this.auditTarget ? this.auditTarget.objectId : undefined,
      });
      this.auditPage = result.page;
      this.auditTotal = result.total;
      this.audits = result.items;
    } catch (error) {
      this.$message.error("비밀번호 초기화 기록을 불러오지 못했습니다.");
    } finally {
      this.auditLoading = false;
    }
  }
}
